import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-column mb-3" };
const _hoisted_2 = { class: "text-normal-regular" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CreateBody = _resolveComponent("CreateBody");
    const _component_EditBody = _resolveComponent("EditBody");
    const _component_ReactivateBody = _resolveComponent("ReactivateBody");
    const _component_ScheduledBody = _resolveComponent("ScheduledBody");
    const _component_ValidationForm = _resolveComponent("ValidationForm");
    const _component_ButtonGroup = _resolveComponent("ButtonGroup");
    const _component_Modal = _resolveComponent("Modal");
    return (_openBlock(), _createBlock(_component_Modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.showModal) = $event)),
        "modal-class": "material-design",
        "is-loading": _ctx.isLoading,
        title: _ctx.modalTitle,
        onHidden: _ctx.clearConfig
    }, {
        "modal-header": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.modalTitle), 1),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.modalDescription), 1)
            ])
        ]),
        "modal-footer": _withCtx(({ hide }) => [
            _createVNode(_component_ButtonGroup, {
                "secondary-button-icon-name": "cancel-circle",
                "primary-button-icon-name": _ctx.primaryButtonIcon,
                "primary-button-text": _ctx.primaryButtonText,
                "secondary-button-text": _ctx.tr('portal.TX_CANCEL'),
                onPrimaryButtonClick: _ctx.onConfirm,
                onSecondaryButtonClick: hide
            }, null, 8, ["primary-button-icon-name", "primary-button-text", "secondary-button-text", "onPrimaryButtonClick", "onSecondaryButtonClick"])
        ]),
        default: _withCtx(() => [
            (_ctx.config)
                ? (_openBlock(), _createBlock(_component_ValidationForm, {
                    key: 0,
                    ref: "validator"
                }, {
                    default: _withCtx(() => [
                        (_ctx.mode === _ctx.Mode.CREATE)
                            ? (_openBlock(), _createBlock(_component_CreateBody, {
                                key: 0,
                                modelValue: _ctx.config,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.config = $event))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (_ctx.mode === _ctx.Mode.EDIT)
                            ? (_openBlock(), _createBlock(_component_EditBody, {
                                key: 1,
                                modelValue: _ctx.config,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_ctx.config = $event))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (_ctx.mode === _ctx.Mode.REACTIVATE)
                            ? (_openBlock(), _createBlock(_component_ReactivateBody, {
                                key: 2,
                                modelValue: _ctx.config,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_ctx.config = $event))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (_ctx.mode === _ctx.Mode.SCHEDULE)
                            ? (_openBlock(), _createBlock(_component_ScheduledBody, {
                                key: 3,
                                modelValue: _ctx.config,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_ctx.config = $event))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                }, 512))
                : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
    }, 8, ["modelValue", "is-loading", "title", "onHidden"]));
}
